let ol = require('openlayers');
let Buffer = require('./operations/buffer');
let IsIntersected = require('./operations/isIntersected');

class EngineSync {
  constructor() {
    this.buffer = new Buffer();
    this.isIntersected = new IsIntersected();
  }

  geometryConstructor(params) {
    let geometryType = params.geometryType || "Point";
    return ol.geom[geometryType];
  }
}

module.exports = EngineSync;